import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";

@Injectable()
export class TimeoutResolve implements Resolve<any> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve("value")
      }, 5000);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/timeout-resolve.ts